module.exports = __webpack_public_path__ + "static/media/amazonlinux.8a520f0b.png";